import React from "react";
export function Header({ children }) {
  return (
    <div>
      <h1>
        {children}
      </h1>
    </div>
  );
};
